import { render, staticRenderFns } from "./transhipDetail.vue?vue&type=template&id=6b05d1ff&scoped=true&"
import script from "./transhipDetail.vue?vue&type=script&lang=js&"
export * from "./transhipDetail.vue?vue&type=script&lang=js&"
import style0 from "./transhipDetail.vue?vue&type=style&index=0&id=6b05d1ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b05d1ff",
  null
  
)

export default component.exports